var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66659 4.66667C9.66659 6.13943 8.47268 7.33333 6.99992 7.33333C5.52716 7.33333 4.33325 6.13943 4.33325 4.66667C4.33325 3.19391 5.52716 2 6.99992 2C8.47268 2 9.66659 3.19391 9.66659 4.66667Z",
    stroke: "#505D67",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 9.33325C4.42259 9.33325 2.33325 11.4226 2.33325 13.9999H11.6666C11.6666 11.4226 9.57725 9.33325 6.99992 9.33325Z",
    stroke: "#505D67",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f4680129416bee774704ff6cbf05ed71.svg";
export { ForwardRef as ReactComponent };